import React, { useState } from 'react';
import { ThemeProvider } from "@pixel/core";
import { createInternalTheme } from "@pixel/internal/styles";
import PageHeader from "@pixel/core/PageHeader";
import Tab from '@pixel/core/Tab';
import Tabs from '@pixel/core/Tabs';
import Typography from '@pixel/core/Typography';
import Box from "@pixel/core/Box";

import LayoutRoot from "@pixel/internal/LayoutRoot";
import LayoutRootSection from "@pixel/internal/LayoutRootSection";

import { LocalizationProvider } from '../../contexts/Localization/LocalizationProvider';
import { LocalizationValues } from '../../contexts/Localization/LocalizationTypes';
import OdsContext from './OdsContext';

import Breadcrumb from "@pixel/core/Breadcrumb";
import BreadcrumbItem from "@pixel/core/BreadcrumbItem";
import DomainProvider from '../../contexts/Domain';

import Locations from './locations/Locations';
import BusinessUnit from './businessUnit/BusinessUnits';
import Departments from './departments/Departments';
import { ConfirmationDialogServiceProvider } from '@pixel/core/ConfirmationService';
import SnackbarServiceProvider, { useSnackbar } from "@pixel/core/SnackbarService";


export const App = (props: any) => {

    const perPageSelectOptions = [{ ariaLabel: "ten", value: 10 },{ ariaLabel: "twenty", value: 20 },{ ariaLabel: "thirty", value: 30 },{ ariaLabel: "fifty", value: 50 }];
    const defaultPageSize = 20;
    const snackBarAutoHideTime = 10000;
    const theme = createInternalTheme({ darkMode: false, theme: {} });

    const [selectedTabValue, setSelectedTabValue] = useState(0);
    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`ODS-tabpanel-${index}`}
                aria-labelledby={`ODS-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <LayoutRootSection>
                        {children}
                    </LayoutRootSection>
                )}
            </div>
        );
    }

    function a11yProps(index: number) {
        return {
            id: `ODS-tab-${index}`,
            'aria-controls': `ODS-tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTabValue(newValue);
    };

    return (
        <React.StrictMode>
            <DomainProvider urls={window.jvUrls}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider locale='en-us' translations={props.translations as LocalizationValues}>
                    <ConfirmationDialogServiceProvider>
                        <SnackbarServiceProvider maxSnack={5}>
                            <OdsContext.Provider value={{ perPageSelectOptions, defaultPageSize, snackBarAutoHideTime }}>
                                <LayoutRoot>
                                    <LayoutRootSection top className='jv-ods-page-header'>
                                        <Box className='container'>
                                            <Breadcrumb>
                                                <BreadcrumbItem href={window.jvUrls.admin + '/config/index.html#/admin/introduction'} label={props.translations.ODS_ADMIN} />
                                                <BreadcrumbItem href={window.jvUrls.admin + '/config/index.html#/configurations/introduction'} label={props.translations.ODS_ADMIN_CONFIGURATION} />
                                                <BreadcrumbItem label={props.translations.ODS_ORGANIZATIONAL_ELEMENTS} />
                                            </Breadcrumb>
                                            <PageHeader title={props.translations.ODS_CREATE_ORG_ELEMENT} >
                                                {props.translations.ODS_CREATE_ORG_ELEMENT_DESC}
                                            </PageHeader>
                                        </Box>
                                    </LayoutRootSection>
                                    <LayoutRootSection className='jv-ods-page-tabs'>
                                        <Box className='container'>
                                            <Tabs value={selectedTabValue} onChange={handleChange}>
                                                <Tab label={<Typography variant="subtitle2" {...a11yProps(0)}>{props.translations.ODS_TAB_BUSINESS_UNITS}</Typography>} />
                                                <Tab label={<div style={{ display: 'flex', alignItems: 'center' }} {...a11yProps(1)}><Typography variant="subtitle2" sx={{ marginRight: '12px' }}>{props.translations.ODS_TAB_LOCATIONS}</Typography></div>} />
                                                <Tab label={<div style={{ display: 'flex', alignItems: 'center' }} {...a11yProps(2)}><Typography variant="subtitle2" sx={{ marginRight: '12px' }}>{props.translations.ODS_TAB_DEPARTMENTS}</Typography></div>} />
                                            </Tabs>
                                        </Box>
                                    </LayoutRootSection>
                                    <LayoutRootSection className='jv-tab-panel' transparent >
                                        <TabPanel value={selectedTabValue} index={0}>
                                            <BusinessUnit></BusinessUnit>
                                        </TabPanel>
                                        <TabPanel value={selectedTabValue} index={1}>
                                            <Locations></Locations>
                                        </TabPanel>
                                        <TabPanel value={selectedTabValue} index={2}>
                                            <Departments></Departments>
                                        </TabPanel>
                                    </LayoutRootSection>
                                </LayoutRoot>
                            </OdsContext.Provider>
                        </SnackbarServiceProvider>
                    </ConfirmationDialogServiceProvider>
                </LocalizationProvider>
            </ThemeProvider>
            </DomainProvider>
        </React.StrictMode>
    );
};

export { react2angular } from "../../lib/react2Angular";
export default App;
